module.exports = __webpack_public_path__ + "img/gmdwxx.d3e78e1d.png";